<template>
  <div class="main-container__header">
    <p class="small">
      <slot>
        {{ $t('globals.no_result') }}
      </slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "NoResult"
}
</script>

<style>

</style>